import { FilterFn } from '@tanstack/react-table';
import moment, { Moment } from 'moment';

declare module '@tanstack/table-core' {
  interface FilterFns {
    dateRange: FilterFn<unknown>
  }
}

const dateRange: FilterFn<any> = (row, columnId, value: { startDate: Moment, endDate: Moment }, addMeta) => {
  let rowValue = row.getValue(columnId);

  if (value == null || rowValue == null) {
    return true;
  }

  let rowValueMoment = moment(rowValue);
  return (
    rowValueMoment.unix() >= moment(value.startDate).startOf('day').unix() &&
    rowValueMoment.unix() <= moment(value.endDate).endOf('day').unix()
  );
};

export default dateRange;
